import './AboutUs.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHandshake, faTruck, faLightbulb } from '@fortawesome/free-solid-svg-icons';

const AboutUs = () => {
  return (
    <section className="about-section">
      <div className="main-content-container about-container">
        <h1 className="about-title">Our Story</h1>
        <p className="about-subtitle">Every big dream starts small.</p>

        <div className="about-content">
          <p>
            <strong>YetiDeals</strong> is a fresh e-commerce startup born from a simple idea — to make online shopping in Nepal
            more <strong>accessible, affordable, and trustworthy</strong> for everyone.
          </p>

          <p>
            Built by a solo founder with a passion for technology and service, YetiDeals isn’t backed by big investors or large teams.
            It’s powered by <strong>dedication, long nights of coding, and a belief in local potential</strong>.
          </p>

          <p>
            Our goal is simple: to bring great products, genuine value, and reliable delivery to every corner of Nepal —
            starting with the basics and growing step by step with your trust.
          </p>
        </div>

        <h2 className="section-heading">Why Shop With Us?</h2>

        <div className="icon-cards">
          <div className="icon-card">
            <FontAwesomeIcon icon={faHandshake} className="icon" />
            <p>
              <strong>Made in Nepal</strong><br />
              Created by locals, for locals — no big corporations involved.
            </p>
          </div>

          <div className="icon-card">
            <FontAwesomeIcon icon={faTruck} className="icon" />
            <p>
              <strong>Delivery You Can Count On</strong><br />
              We aim to reach even remote areas with care and consistency.
            </p>
          </div>

          <div className="icon-card">
            <FontAwesomeIcon icon={faLightbulb} className="icon" />
            <p>
              <strong>Always Improving</strong><br />
              We're constantly learning and evolving — your feedback drives us.
            </p>
          </div>
        </div>

        <div className="final-note">
          <p>
            We’re just getting started, but we’re here to stay — and grow with you.
            Thank you for supporting a new local venture.
          </p>

          <p className="inspiration">
            <em>“From one dreamer to many — thanks for believing in the beginning.”</em>
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;